import React from 'react';
import PolicyPageLayout from '../components/PolicyPageLayout';

const CancellationPolicyPage = () => {
  return (
    <PolicyPageLayout title="Cancellation Policy">
      <h2>Timeframe for Cancellation</h2>
      <p>
        You can request to cancel your order within <strong>24 hours</strong> of placing it, provided it has not already been dispatched.
      </p>
      <p>
        Orders cannot be cancelled once they have been dispatched from our warehouse.
      </p>

      <h2>Cancellation Fee</h2>
      <p>
        If you cancel your prepaid order, a transaction fee of <strong>2% of the total order amount</strong> will be deducted when we process your refund. This fee covers the payment gateway charges that are not refunded to us.
      </p>

      <h2>How to Cancel</h2>
      <p>
        To cancel your order, please contact our customer support team immediately with your order number.
      </p>
      <ul>
        <li>Email: <strong>monvistyles@gmail.com</strong></li>
        <li>WhatsApp: <strong>+91 9676111210</strong></li>
      </ul>
    </PolicyPageLayout>
  );
};

export default CancellationPolicyPage;